var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('input',{staticClass:"hidden-checkbox",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isChecked)?[_vm._t("on",[_c('span',[_vm._v("ON")])])]:[_vm._t("off",[_c('span',[_vm._v("OFF")])])],_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a59d19a2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Checkbox.vue
// module id = 1040
// module chunks = 1